module.exports = __webpack_public_path__ + "img/Verjuengung_2.bb0f9c73.jpg";